import { inject } from '@angular/core';
import { CanActivateFn, ActivatedRouteSnapshot, UrlTree, Router } from '@angular/router';

export const paramsToStateGuard = <T>(
  requiredStateProperties: (keyof T)[],
  redirectPath: string[],
  routeStateKey: string,
): CanActivateFn => {
  return (route: ActivatedRouteSnapshot): boolean | UrlTree => {
    const router = inject(Router);
    const queryParams = route.queryParams as Partial<T>;

    const isKeyMissing = requiredStateProperties.some((key) => !queryParams[key]);
    if (isKeyMissing) {
      return router.createUrlTree(['/error']);
    }

    router.navigate(redirectPath, {
      state: {
        [routeStateKey]: queryParams,
      },
    });

    return false;
  };
};
